import { render, staticRenderFns } from "./EventFormDialog.vue?vue&type=template&id=b4a90f04&scoped=true"
import script from "./EventFormDialog.vue?vue&type=script&lang=js"
export * from "./EventFormDialog.vue?vue&type=script&lang=js"
import style0 from "./EventFormDialog.vue?vue&type=style&index=0&id=b4a90f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a90f04",
  null
  
)

export default component.exports